'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  background: none;\n  border: 0;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  height: 44px;\n  justify-content: center;\n  margin: 1px;\n  transition: 0.3s;\n  width: 44px;\n\n  & > svg {\n    height: auto;\n    transition: transform 0.3s;\n    width: 24px;\n  }\n\n  &:hover > svg {\n    fill: #fff;\n  }\n\n  @media (any-hover: none) {\n    &:hover {\n      background: none;\n      box-shadow: none;\n    }\n  }\n\n  @media (min-width: 330px) {\n    margin: 5px;\n  }\n\n  @media (min-width: 600px) {\n    margin: 7px;\n  }\n\n  @media (min-width: 1025px) {\n    margin: 10px;\n  }\n'], ['\n  align-items: center;\n  background: none;\n  border: 0;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  height: 44px;\n  justify-content: center;\n  margin: 1px;\n  transition: 0.3s;\n  width: 44px;\n\n  & > svg {\n    height: auto;\n    transition: transform 0.3s;\n    width: 24px;\n  }\n\n  &:hover > svg {\n    fill: #fff;\n  }\n\n  @media (any-hover: none) {\n    &:hover {\n      background: none;\n      box-shadow: none;\n    }\n  }\n\n  @media (min-width: 330px) {\n    margin: 5px;\n  }\n\n  @media (min-width: 600px) {\n    margin: 7px;\n  }\n\n  @media (min-width: 1025px) {\n    margin: 10px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  & > svg {\n    fill: ', ';\n  }\n\n  &:hover {\n    background: ', ';\n    box-shadow: 0 0 10px ', ';\n  }\n\n  @media (any-hover: none) {\n    &:hover > svg {\n      fill: ', ';\n    }\n  }\n'], ['\n  & > svg {\n    fill: ', ';\n  }\n\n  &:hover {\n    background: ', ';\n    box-shadow: 0 0 10px ', ';\n  }\n\n  @media (any-hover: none) {\n    &:hover > svg {\n      fill: ', ';\n    }\n  }\n']);

var _emotion = require('emotion');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

var _ShareButton = require('../ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var styles = (0, _emotion.css)(_templateObject);

var dynamicStyles = function dynamicStyles(props) {
  return (0, _emotion.css)(_templateObject2, _colors2.default[props.network], _colors2.default[props.network], _colors2.default[props.network], _colors2.default[props.network]);
};

var ShareButtonIconOnly = function ShareButtonIconOnly(props) {
  var className = props.className,
      rest = _objectWithoutProperties(props, ['className']);

  var dynamicStylesStr = dynamicStyles(props);

  return _react2.default.createElement(_ShareButton2.default, _extends({
    className: (0, _emotion.cx)(styles, dynamicStylesStr, className)
  }, rest));
};

ShareButtonIconOnly.propTypes = {
  className: _propTypes2.default.any
};

exports.default = ShareButtonIconOnly;


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-share/dist/styled/ShareButtonIconOnly.js
// module id = 388
// module chunks = 168707334958949